export const TransaccionStatus = ({ status }) => {
    let statusText = '';
    let bgColor = '';
    let textColor = '';

    switch (status) {
        case 'pagado':
            statusText = 'Pagado';
            bgColor = 'bg-green-100';
            textColor = 'text-green-800';
            break;
        case 'pendiente':
            statusText = 'Pendiente';
            bgColor = 'bg-amber-100';
            textColor = 'text-amber-800';
            break;
        default:
            statusText = 'Aplicado';
            bgColor = 'bg-blue-100';
            textColor = 'text-blue-800';
    }

    return (
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold capitalize ${bgColor} ${textColor}`}>
            {statusText}
        </span>
    );
};